import React from 'react';
import HeaderComponent from '../../components/header';
// import Languages from '../../components/languages/indes';
import MenuOptions from '../../components/menuOptions';
import FrameImage from '../../components/frameImage';
import Collaborators from '../../components/collaborators';
import { Volunteers } from '../../components/image-router';
import OursContent from '../../components/oursContent';
import Donations from '../../components/donations';

const Ours = () => {
    return (
        <>
            <div>
                <FrameImage image={Volunteers} section="ours" />
            </div>
            <div>
                <Collaborators />
            </div>
            <div>
                <OursContent />
            </div>
            <div>
                <Donations />
            </div>
        </>



    );
}

export default Ours;